// src/components/communications/CommunicationsTable.js
import React from 'react';
import { PencilIcon, PaperAirplaneIcon, EyeIcon } from '@heroicons/react/24/outline';

const CommunicationsTable = ({ messages, onEditMessage, onSendMessage }) => {
    const getStatusClasses = (status) => {
        switch (status) {
            case 'Sent': return 'bg-green-100 text-green-800';
            case 'Scheduled': return 'bg-blue-100 text-blue-800';
            case 'Draft': return 'bg-gray-100 text-gray-800';
            case 'Failed': return 'bg-red-100 text-red-800';
            default: return 'bg-gray-100 text-gray-800';
        }
    };

    return (
        <div className="bg-white rounded-lg shadow-md overflow-hidden mt-6">
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                    <tr>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Message Name
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Audience
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Status
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Sent/Scheduled
                        </th>
                        <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Performance
                        </th>
                        <th scope="col" className="relative px-6 py-3">
                            <span className="sr-only">Actions</span>
                        </th>
                    </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                    {messages.length === 0 ? (
                        <tr>
                            <td colSpan="7" className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                No messages found matching your criteria.
                            </td>
                        </tr>
                    ) : (
                        messages.map((msg) => (
                            <tr key={msg.id} className="hover:bg-gray-50 transition-colors">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">{msg.name}</div>
                                    {msg.subject && <div className="text-xs text-gray-500 truncate max-w-xs">Subject: {msg.subject}</div>}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-600">{msg.type}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm text-gray-600">{msg.audience}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusClasses(msg.status)}`}>
                      {msg.status}
                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600">
                                    {msg.status === 'Sent' ? msg.sentDate : msg.scheduledDate || 'N/A'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <div>Sent: {msg.sentCount.toLocaleString()}</div>
                                    {msg.type === 'Email' && <div>Opens: {msg.opens?.toLocaleString() || 'N/A'}</div>}
                                    <div>Clicks: {msg.clicks?.toLocaleString() || 'N/A'}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                    {(msg.status === 'Draft' || msg.status === 'Scheduled') && (
                                        <button
                                            onClick={() => onEditMessage(msg)}
                                            className="text-indigo-600 hover:text-indigo-900 p-1 rounded-full hover:bg-gray-100 transition-colors"
                                            title="Edit Message"
                                        >
                                            <PencilIcon className="h-5 w-5" />
                                        </button>
                                    )}
                                    {msg.status === 'Draft' && (
                                        <button
                                            onClick={() => onSendMessage(msg.id)}
                                            className="text-green-600 hover:text-green-900 p-1 rounded-full hover:bg-gray-100 transition-colors ml-2"
                                            title="Send Message Now"
                                        >
                                            <PaperAirplaneIcon className="h-5 w-5" />
                                        </button>
                                    )}
                                    <button
                                        // This would open a detailed view of the message content and full performance
                                        onClick={() => alert('View details for ' + msg.name)}
                                        className="text-gray-600 hover:text-gray-900 p-1 rounded-full hover:bg-gray-100 transition-colors ml-2"
                                        title="View Details"
                                    >
                                        <EyeIcon className="h-5 w-5" />
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CommunicationsTable;